module.exports = __webpack_public_path__ + "img/9广东省公共资源交易现代科学信息技术应用与创新二等奖.0212dee7.png";